//src/assets/scripts/about.js

import PageJS from './programs/page';
import CommonJS from './common';
const common = new CommonJS();
const page = new PageJS(common);
page.init();